var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompactList = function SvgCompactList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.117 2.021a.98.98 0 1 1 0-1.96.98.98 0 1 1 0 1.96M4.57 1.67a.62.62 0 0 1-.633-.625.62.62 0 0 1 .633-.633h10.672c.352 0 .633.274.633.633a.624.624 0 0 1-.633.625zM1.117 5.982a.98.98 0 1 1 0-1.96.98.98 0 1 1 0 1.96m3.453-.351a.62.62 0 0 1-.633-.625.62.62 0 0 1 .633-.633h10.672c.352 0 .633.273.633.633a.624.624 0 0 1-.633.625zM1.117 9.943a.98.98 0 1 1 0-1.96.98.98 0 1 1 0 1.96m3.453-.351a.62.62 0 0 1-.633-.625.62.62 0 0 1 .633-.633h10.672c.352 0 .633.273.633.633a.624.624 0 0 1-.633.625z"
  })));
};
export default SvgCompactList;